import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, WhatsappLogo, GoogleLogo } from "@phosphor-icons/react";
import { useLang } from "@/lib/LanguageContext";
import { wa } from "@/lib/pfd";
import { GOOGLE_REVIEW_URL, REVIEW_WA_MSG, THANK_YOU } from "@/lib/reviews";
import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";
import ImageHero from "@/components/ImageHero";

export default function ThankYouPage() {
  const { lang, setLang } = useLang();
  const { search } = useLocation();
  useEffect(() => {
    const q = new URLSearchParams(search).get("lang");
    if ((q === "fr" || q === "en") && q !== lang) setLang(q);
  }, [search, lang, setLang]);
  const c = THANK_YOU[lang];

  return (
    <PageShell>
      <Seo title={c.seoTitle} description={c.text} noindex />
      <ImageHero testId="thank-you-hero" image="apartment" eyebrow={c.eyebrow} titleA={c.h1a} titleB={c.h1b} />
      <section data-testid="thank-you-body" className="py-16 sm:py-32 px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          <p className="text-stone-700 text-base md:text-lg leading-relaxed">{c.text}</p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              data-testid="review-google-cta"
              href={GOOGLE_REVIEW_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() => window.gtag && window.gtag("event", "review_google_click")}
              className="inline-flex items-center justify-center gap-3 bg-slate-900 text-stone-50 px-8 py-4 text-sm font-medium hover:bg-slate-800 transition-colors"
            >
              <GoogleLogo size={16} /> {c.google}
            </a>
            <a
              data-testid="review-whatsapp-cta"
              data-no-wa-track
              href={wa(REVIEW_WA_MSG[lang])}
              target="_blank"
              rel="noreferrer"
              onClick={() => window.gtag && window.gtag("event", "review_whatsapp_click")}
              className="inline-flex items-center justify-center gap-3 border border-stone-300 text-stone-800 px-8 py-4 text-sm font-medium hover:border-stone-900 transition-colors"
            >
              <WhatsappLogo size={16} /> {c.wa}
            </a>
          </div>
          <p className="mt-6 text-xs text-stone-500 italic">{c.note}</p>
          <Link data-testid="thank-you-back" to="/" className="mt-12 inline-flex items-center gap-2 text-sm text-stone-800 border-b border-stone-300 hover:border-stone-900 py-2 transition-colors">
            {c.back} <ArrowRight size={13} />
          </Link>
        </div>
      </section>
    </PageShell>
  );
}
